import React from 'react'
import { Typography, Box, Button } from '@mui/material'
import { Add } from '@mui/icons-material'
import { MAX_ALLOWED_STAGES } from '../../constants'
import StageView from './StageView'

const PipelineView = ({
  pipeline,
  moveStage,
  removeStage,
  addStage,
  updateStage,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          width: '572px',
        }}
      >
        <Box
          sx={{
            alignSelf: 'flex-start',
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            pr: 2,
          }}
        >
          <Box
            sx={{
              alignSelf: 'flex-start',
              mb: 1,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography variant={'h6'} sx={{ mr: 1 }}>
              Pipeline name:{' '}
            </Typography>
            {/* NICE-TO-HAVE: add esc and enter for quality of life */}
            {/* {isEditingName ? (
              <TextField
                autoFocus
                onChange={(e) => {
                  if (e.target.value.length > PIPELINE_NAME_MAX_LENGTH) return
                  updatePipeline({ name: e.target.value })
                }}
                size='small'
                value={pipeline.name}
              />
            ) : ( */}
            <Typography variant={'h6'} sx={{ fontWeight: 'bold' }}>
              {pipeline.name}
            </Typography>
            {/* )} */}

            {/* <IconButton
              color='primary'
              onClick={() => setIsEditingName(!isEditingName)}
            >
              {isEditingName ? <Check /> : <Edit />}
            </IconButton> */}
          </Box>
          {/* 
          <Button
            color={'error'}
            endIcon={<Delete />}
            onClick={() => removePipeline(pipeline)}
          >
            Remove Pipeline
          </Button> */}
        </Box>
        {pipeline.stages.map((s, i) => (
          <StageView
            key={i}
            stage={s}
            index={i}
            stages={pipeline.stages}
            moveStage={moveStage}
            removeStage={removeStage}
            updateStage={updateStage}
          />
        ))}
        <Button
          sx={{ mt: 1 }}
          color={'primary'}
          onClick={addStage}
          endIcon={<Add />}
          disabled={pipeline.stages.length >= MAX_ALLOWED_STAGES}
        >
          Add a stage
        </Button>
      </Box>
    </Box>
  )
}
export default PipelineView
